const t = "tradeininstock:events", e = "initialized", n = "form_field_value_changed", c = "button_clicked", E = "back-button", o = "reset-form-button", _ = "save-result-button", a = "calculate-cost-button", v = "fill-manually-button", T = {
  event: "customEvent",
  eventCategory: "avn-tradein",
  eventAction: "click",
  eventLabel: "step1-fill-manually"
}, s = {
  event: "customEvent",
  eventCategory: "avn-tradein",
  eventAction: "click",
  eventLabel: "step2-back"
}, A = {
  event: "customEvent",
  eventCategory: "avn-tradein",
  eventAction: "click",
  eventLabel: "step2-calc"
}, L = {
  event: "customEvent",
  eventCategory: "avn-tradein",
  eventAction: "click",
  eventLabel: "step1-next"
}, N = {
  event: "customEvent",
  eventCategory: "avn-tradein",
  eventAction: "click",
  eventLabel: "step3-save"
}, i = {
  event: "customEvent",
  eventCategory: "avn-tradein",
  eventAction: "click",
  eventLabel: "step3-restart"
};
export {
  A as ANALYTIC_EVENT_CALC_PRICE,
  L as ANALYTIC_EVENT_CONTINUE,
  T as ANALYTIC_EVENT_FILL_MANUALLY,
  s as ANALYTIC_EVENT_PREV_STAGE,
  i as ANALYTIC_EVENT_RESET_RESULT,
  N as ANALYTIC_EVENT_SAVE_RESULT,
  E as BUTTON_ID_BACK,
  a as BUTTON_ID_CALCULATE_COST,
  v as BUTTON_ID_FILL_MANUALLY,
  o as BUTTON_ID_RESET_FORM,
  _ as BUTTON_ID_SAVE_RESULT,
  t as EVENTS_CHANNEL,
  c as EVENT_BUTTON_CLICKED,
  n as EVENT_FORM_FIELD_VALUE_CHANGED,
  e as EVENT_WIDGET_INITIALIZED
};
